<template>
  <v-layout row align-center justify-center>
    <v-flex xs10 md8 lg8>
        <v-card color="white">
          <v-card-title primary-title>
            <h3 class="headline">Dados da empresa</h3>
          </v-card-title>
          <v-form @submit.prevent="onSubmit">
          <v-card-text>
            <v-layout row px-2>
              <v-flex><span v-if="error" class="error--text">{{error}}</span></v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm2 px-1>
                <v-select
                  @change="form.cnpj=''"
                  v-model="showCPF"
                  :items="[{text:'Jurídica',value:false},{text:'Física',value:true}]"
                  label="Tipo de pessoa"
                ></v-select>
              </v-flex>
              <v-flex sm4>
                <v-text-field label="CPF" v-model="form.cnpj" name="cpf" 
                  mask="###.###.###-##" v-if="showCPF">
                </v-text-field>
                <v-text-field label="CNPJ" v-model="form.cnpj" name="cnpj" 
                  mask="##.###.###/####-##" v-else @change="searchCNPJ" :loading="loadingCNPJ">
                </v-text-field>
              </v-flex>
              <v-flex sm6 px-2>
                <v-text-field :label="showCPF?'Nome':'Razão Social'" 
                  v-model="form.razao_social" name="razao_social">
                </v-text-field>
              </v-flex>
              <v-flex sm6 px-1>
                <v-text-field label="Whatsapp da loja" v-model="form.phone" name="phone"
                  mask="(##) #####-####" type="tel" required data-vv-name="phone"
                  v-validate="'required|min:10|max:11'" 
                  :error-messages="errors.collect('phone')">
                </v-text-field>
              </v-flex>
              <v-flex sm6 px-1>
                <v-text-field label="Email financeiro" v-model="form.email" name="email">
                </v-text-field>
              </v-flex>
              <v-flex sm3 px-1>
                <v-text-field label="CEP" v-model="form.cep" name="cep"
                  :error-messages="cepError"
                  @blur="
                    (_) => {
                      if (cepError) {
                        cep = ''
                        cepError = null
                      }
                    }
                  "
                  @input="viacep(form.cep)"
                  @click:clear="
                    (_) => {
                      cepLocked = false
                      cepError = null
                    }
                  "
                  mask="#####-###"
                  clearable
                >
                </v-text-field>
              </v-flex>
              <v-flex sm4 px-1>
                <v-select label="Estado" v-model="form.state" :items="states"
                  item-value="_id" item-text="nome" @change="loadCities"
                  required data-vv-name="state" name="estate"
                  v-validate="'required'" 
                  :error-messages="errors.collect('state')">
                </v-select>
              </v-flex>
              <v-flex sm5 px-1>
                <v-autocomplete v-model="form.city" :items="cities" item-value="_id" item-text="nome"
                  label="Cidade" :loading="loadingUF" browser-autocomplete="none" :disabled="form.state==null"
                  required data-vv-name="city" name="city" :filter="filter"
                  v-validate="'required'" 
                  :error-messages="errors.collect('city')">
                </v-autocomplete>
              </v-flex>
              <v-flex sm6 px-1>
                <v-text-field label="Endereço" v-model="form.address" name="address">
                </v-text-field>
              </v-flex>
              <v-flex sm2 px-1>
                <v-text-field label="Número" v-model="form.number" name="number">
                </v-text-field>
              </v-flex>
              <v-flex sm4 px-1>
                <v-text-field label="Bairro" v-model="form.district" name="district">
                </v-text-field>
              </v-flex>
              <v-flex sm8 px-1>
                <v-text-field label="Complemento" v-model="form.cmplt" name="cmplt">
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat type="submit" @click="$router.back()">
              Cancelar
            </v-btn>
            <v-btn color="secondary" type="submit" :loading="loading" :disabled="loading">
              Confirmar
            </v-btn>
          </v-card-actions>
          </v-form>
        </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import Axios from 'axios'
import store from '../store/index'

export default {
  data() {
    return {
      loadingUF: false,
      form:{
        cnpj:'',
        razao_social:'',
        inscricao_municipal:'',
        phone:'',
        email:'',
        address:'',
        number:'',
        district:'',
        cmplt:'',
        cep:'',
        state:'',
        city:''
      },
      showCPF:false,
      cepError:'',
      error:null,
      loading:false,
      loadingCNPJ:false
    }
  },
  computed: {
    ...mapGetters([
      'cities',
      'states',
      'user',
      'restaurant'
    ]),
  },
  async beforeRouteEnter(to, from, next) {
    if(store.state.user == null)
      next({name:'Login'})
    else{
      await store.dispatch('getStates')
      next()
    }
  },
  watch:{
    restaurant(v){
      this.loadForm()
    }
  },
  mounted(){
    this.loadForm()
  },
  methods:{
    getStateId(uf){
      return this.states.find((v)=>v.sigla == uf)
    },
    getCityId(name){
      return this.cities.find((v)=>v.nome == name)
    },
    async viacep(cep) {
      try {
        if (cep.length == 8) {
          const res = await this.$store.dispatch('viaCep', cep)
          if (!res.erro) {
            this.cepError = null
            const state = this.getStateId(res.uf)
            if(state){
              this.form.state = state._id
              await this.loadCities()
              const city = this.getCityId(res.localidade)
              if(city){
                this.form.city = city._id
              }
            }
            if (res.bairro != '') {
              this.form.district = res.bairro
            }
            if (res.logradouro != '') {
              this.form.address = res.logradouro
            }
          } else {
            this.cepError =
              'CEP não encontrado. Tente novamente ou busque pelo endereço.'
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    filter(item, queryText, itemText){
        return item.value.toLocaleLowerCase()
        .indexOf(this.replaceSpecialChars(queryText.toLocaleLowerCase())) > -1
    },
    replaceSpecialChars(str)
    {
        str = str.replace(/[ÀÁÂÃ]/,"A");
        str = str.replace(/[àáâã]/,"a");
        str = str.replace(/[ÈÉÊẼ]/,"E");
        str = str.replace(/[èéêẽ]/,"e");
        str = str.replace(/[ÌÍÎĨ]/,"I");
        str = str.replace(/[ìíîĩ]/,"i");
        str = str.replace(/[ÒÓÔÕ]/,"O");
        str = str.replace(/[òóôõ]/,"o");
        str = str.replace(/[ÙÚÛŨ]/,"U");
        str = str.replace(/[ùúûũ]/,"u");
        str = str.replace(/[Ç]/,"C");
        str = str.replace(/[ç]/,"c");

        return str.replace(/[^a-z0-9]/gi,''); 
    },
    loadForm(){
      if(this.restaurant){
        this.form.cnpj = this.restaurant.cnpj
        if(this.form.cnpj && this.form.cnpj.length == 11 ){
          this.showCPF = true
        }
        this.form.razao_social = this.restaurant.razao_social
        this.form.phone = this.restaurant.default_phone.substr(1)
        this.form.email = this.restaurant.default_email || this.user.email
        this.form.address = this.restaurant.default_address
        this.form.number = this.restaurant.default_address_number
        this.form.district = this.restaurant.default_address_district
        this.form.cmplt = this.restaurant.default_address_cmplt
        this.form.cep = this.restaurant.default_address_cep
        this.form.state = this.restaurant.default_address_state
        this.loadCities()
        this.form.city = this.restaurant.default_address_city
      }
    },
    async searchCNPJ(){
      if(this.form.cnpj.length == 14){
        try {
          this.loadingCNPJ = true
          const res = await Axios.get(`https://api.socialplace.com.br/api/searchcnpj?cnpj=${this.form.cnpj}`)
          if(res.data.data.status=="ERROR"){
            this.error=res.data.data.message
          } else {
            this.error=null
            this.form.razao_social = res.data.data.nome || ''
            this.form.address = res.data.data.logradouro || ''
            this.form.number = res.data.data.numero || ''
            this.form.district = res.data.data.bairro || ''
            this.form.cmplt = res.data.data.complemento || ''
            this.form.cep = res.data.data.cep || ''
            let state = this.states.find(s=>s.sigla==res.data.data.uf)
            if(state){
              this.form.state = state._id
              this.loadCities()
            }
          }
        } catch (error) {
          this.error = "Algo inesperado aconteceu, tente novamente mais tarde."
        } finally {
          this.loadingCNPJ = false
        }
      }else{
        this.error = null
      }
    },
    async onSubmit(event){
      try {
          this.loading = true
          let valid = await this.$validator.validateAll()
          if(valid){
              let res = await this.$store.dispatch('updateRestaurant',this.form)
              if(!res.ok){
                  this.error = res.error
              }else{
                  this.error = null
                  this.$router.push({name:'AllProducts'})
              }
          }
      } catch (error) {
          this.error = error
      } finally {
        this.loading = false
      }
    },
    async loadCities(){
        if(!this.form.state)return

        this.loadingUF = true
        await this.$store.dispatch('getCities',this.form.state)
        this.loadingUF = false
      }
  }
}
</script>

<style>

</style>